import { forEach } from 'lodash';
import humps from 'lodash-humps';

const state = {
    fr: {
        appointmentCancelledText: '',
        appointmentReminderText: '',
        isPopupActivated: false,
        lang: 'fr',
        popupText: '',
        popupTitle: '',
        presentationText: '',
        presentationTitle: '',
        privacyText: '',
        publicSiteDeactivatedText: '',
        publicPageFooter: '',
    },
    en: {
        appointmentCancelledText: '',
        appointmentReminderText: '',
        isPopupActivated: false,
        lang: 'en',
        popupText: '',
        popupTitle: '',
        presentationText: '',
        presentationTitle: '',
        privacyText: '',
        publicSiteDeactivatedText: '',
        publicPageFooter: '',
    },
};

const getters = {
    getTexts: (state) => {
        return state;
    },
};

const mutations = {
    UPDATE_TEXTS(state, data) {
        state[data.lang] = data;
    },
};

const actions = {
    /**
     * @description Fetch all texts for an establishment
     * @param commit
     * @param rootGetters
     * @param establishmentId
     * @returns {Q.Promise<any>}
     */
    getTexts({ commit, rootGetters }, establishmentId) {
        return this._vm.$api.texts.get(establishmentId)
            .then(res => {
                forEach(res.data, d => { commit('UPDATE_TEXTS', humps(d)); });
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
